import dcx from "dcx";

import selectors from "@/lib/selectors";

const { product: selector } = selectors;

const classes = {
  activeThumb: "active-thumbnail",
  hide: "hide",
};

const switchImage = function (imageId, autoPlay) {
  if (!imageId) return;
  const section = this.container;

  const firstModel = this.container.querySelector("[data-first-model-id]");
  const firstModelId = firstModel && firstModel.dataset.firstModelId;
  const inYourSpaceButton = this.container.querySelector(
    ".bttn.product__in-space-bttn"
  );

  const newImage = section.querySelector(
    selector.imageWrapper + selector.imageById(imageId)
  );

  const otherImages = section.querySelectorAll(
    `${selector.imageWrapper}:not(${selector.imageById(imageId)})`
  );

  newImage.classList.remove(classes.hide);
  handleZoomButton.call(this, newImage);
  otherImages.forEach(image => image.classList.add(classes.hide));

  if (inYourSpaceButton) {
    if (newImage.dataset.type === "model") {
      inYourSpaceButton.setAttribute(
        "data-shopify-model3d-id",
        newImage.dataset.imageId
      );
    } else {
      inYourSpaceButton.setAttribute("data-shopify-model3d-id", firstModelId);
    }
  }
};

const setActiveThumbnail = function (imageId) {
  const section = this.container;
  let newImageId = imageId;

  if (typeof newImageId === "undefined") {
    newImageId = section.querySelector(
      `${selector.imageWrapper}:not('.${classes.hide}')`
    ).dataset.imageId;
  }

  const thumbnail = section.querySelector(
    selector.thumb + selector.thumbById(newImageId)
  );

  if (!thumbnail) return;

  section.querySelectorAll(selector.thumb).forEach(thumb => {
    thumb.classList.remove(classes.activeThumb);
  });
  thumbnail.classList.add(classes.activeThumb);
};

const handleZoomButton = function (newImage) {
  const el = this.container.querySelector(selector.zoom);
  if (!el) return;

  const imageLink = newImage.querySelector("a.product__image");
  const btn = dcx(el);

  btn({
    hide: !Boolean(imageLink),
  });
};

export default function (id, autoPlay) {
  switchImage.call(this, id, autoPlay);
  setActiveThumbnail.call(this, id);
}
